import React from 'react'

function Listing() {
  
  return (
    <div>Listing</div>
  )
}

export default Listing